"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _redux = require("redux");
var _admin = _interopRequireDefault(require("./reducers/admin.js"));
var _player = _interopRequireDefault(require("./reducers/player.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = (0, _redux.combineReducers)({
  admin: _admin["default"],
  player: _player["default"]
});